import script from "./ExpiredTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpiredTasks.vue?vue&type=script&setup=true&lang=js"

import "./ExpiredTasks.vue?vue&type=style&index=0&id=6b500ae4&lang=scss"

const __exports__ = script;

export default __exports__